import { MDBAlert, MDBBtn, MDBSpinner } from 'mdb-react-ui-kit';
import React, { useEffect, useState } from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';
import { getStreamSettingsDetails, updateGlobalSettings } from '../../../apiclients/streamsapi_bridge';
import SaveChanges from '../saveCancel';

function Streamssettings({ register, setValue, errors, watch }) {
    const { t, i18n } = useTranslation();
    return (
        <>
            {/* <h3>Streams Settings</h3> */}

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>Show Colleagues team</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.show_colleagues_team")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>Show Company (Automatic) teams</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.show_company_teams")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>SMS</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.sms")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>Delete Message</p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.delete_msg")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>

            <div className="add-numbermain">
                <div className="tel-numbers">
                    <p>DND Option</p>
                    <p className='phrecording text-secondary'>
                        {/* Changes subtext Jerome's Enhancements suggested changes */}
                        {/* When this setting is enabled, the DND option becomes available to all users in the account who have activated the user-level DND setting. Conversely, disabling this setting renders the DND option unavailable for all users in the account. */}
                        Disable Do Not Disturb on Softphones
                    </p>
                </div>
                <div className="phoneselect w-30">
                    <div>
                        <label className="switch">
                            <input className="form-control" type="checkbox" {...register("global_settings.streams_settings.do_not_disturb")} />
                            <span className="slider round"></span>
                        </label>
                    </div>
                </div>
            </div>
           
        </>
    )
}

export default Streamssettings
